// extracted by mini-css-extract-plugin
export default {"title":"Section_title__H9e+4"};